import Api from "@/api/base";

export const API_CONTOUR_LEGACY = "legacy";
export const API_CONTOUR_ORCHESTRATOR = "orchestrator";

const API_CONTOUR_STORAGE_KEY = "api_contour";
const PENDING_API_CONTOUR_STORAGE_KEY = "pending_api_contour";
const SUPPORTED_CONTOURS = [API_CONTOUR_LEGACY, API_CONTOUR_ORCHESTRATOR];

class ApiContourService {
  normalize(contour) {
    if (typeof contour !== "string") {
      return null;
    }

    const normalized = contour.trim().toLowerCase();
    return SUPPORTED_CONTOURS.includes(normalized) ? normalized : null;
  }

  getConfiguredBaseUrl(contour) {
    if (contour === API_CONTOUR_LEGACY) {
      return process.env.VUE_APP_API_HOST || "";
    }

    if (contour === API_CONTOUR_ORCHESTRATOR) {
      return process.env.VUE_APP_OPERATOR_API_HOST || "";
    }

    return "";
  }

  initialize() {
    const localContour = this.normalize(window.localStorage.getItem(API_CONTOUR_STORAGE_KEY));
    const sessionContour = this.normalize(window.sessionStorage.getItem(API_CONTOUR_STORAGE_KEY));
    const storedContour = localContour || sessionContour;
    const contour = storedContour && this.getConfiguredBaseUrl(storedContour)
      ? storedContour
      : API_CONTOUR_LEGACY;

    if (storedContour && contour !== storedContour) {
      window.localStorage.removeItem(API_CONTOUR_STORAGE_KEY);
      window.sessionStorage.removeItem(API_CONTOUR_STORAGE_KEY);
    } else if (!localContour && storedContour) {
      window.localStorage.setItem(API_CONTOUR_STORAGE_KEY, storedContour);
      window.sessionStorage.removeItem(API_CONTOUR_STORAGE_KEY);
    }

    return {
      baseUrl: this.getConfiguredBaseUrl(contour),
      contour,
    };
  }

  getCurrentContour() {
    return this.initialize().contour;
  }

  getPendingContour() {
    return this.normalize(window.sessionStorage.getItem(PENDING_API_CONTOUR_STORAGE_KEY));
  }

  defer(contour) {
    const normalized = this.normalize(contour);
    if (!normalized) {
      return false;
    }

    window.sessionStorage.setItem(PENDING_API_CONTOUR_STORAGE_KEY, normalized);
    return true;
  }

  clearPending() {
    window.sessionStorage.removeItem(PENDING_API_CONTOUR_STORAGE_KEY);
  }

  activate(contour) {
    const normalized = this.normalize(contour);
    if (!normalized) {
      return { ok: false, reason: "unsupported_contour" };
    }

    const baseUrl = this.getConfiguredBaseUrl(normalized);
    if (!baseUrl) {
      return { ok: false, reason: "missing_api_host" };
    }

    window.localStorage.setItem(API_CONTOUR_STORAGE_KEY, normalized);
    window.sessionStorage.removeItem(API_CONTOUR_STORAGE_KEY);
    this.clearPending();
    Api.init(baseUrl);

    return {
      baseUrl,
      contour: normalized,
      ok: true,
    };
  }
}

export default new ApiContourService();
